import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { useAskAiEntryPoint } from '@upright/ui/chat/use-ask-ai-entry-point';
import styled from 'styled-components';
import { Item, ItemLink, MenuTitleSmall, Section } from '../../shared-menus';

/**
 * Mobile burger-menu entry point for the AI chat at `/chat`. Uses the shared
 * `useAskAiEntryPoint` gate (same logic as the desktop and DMA-header entry
 * points): renders only when the caller holds the `USE_AI_CHAT_WEB`
 * resourceless privilege, and — PLT-5235 (option C) — is hidden for a
 * multi-company DMA Consultant who is off-company. On any entity page — a
 * company, a fund or a portfolio — the link carries that entity's context so
 * the chat opens about it (and on a company the turn is attributed to it too).
 *
 * This is the one entry point with no side-panel fallback: it is href-only, so
 * the shared hook's URL is the only thing that can carry context here. That is
 * why the href being gated to companies meant Ask AI on a fund page had never
 * carried the fund on mobile at all (PLT-6554).
 *
 * Owns its own `<Section>` wrapper so the surrounding divider collapses
 * cleanly when the block is hidden (rather than leaving an empty
 * border-topped section behind).
 */
export const AskAiBlock = () => {
  const { hidden, href } = useAskAiEntryPoint('public');
  if (hidden) {
    return null;
  }
  return (
    <Section>
      <Root>
        <MenuTitleSmall>Ask AI</MenuTitleSmall>
        <Item key="ai-chat">
          <ItemLink data-testid={E2eTestElementId.MOBILE_ASK_AI_LINK} to={href}>
            Open chat
          </ItemLink>
        </Item>
      </Root>
    </Section>
  );
};

const Root = styled.div``;
